module.exports = __webpack_public_path__ + "img/icon43.0aeb6dd5.png";